<template>
  <page-content title="Konsultasi Psikologi" :with-margin="false">
    <vue-tabs>
      <v-tab title="Menunggu">
        <mental-health-participant-list
          :data="unscheduleds"
          @item-click="openCheckupDetail"
          search-placeholder="Cari nama atau keluhan..."
          show-name
        />
      </v-tab>
      <v-tab title="Terjadwal">
        <mental-health-participant-list
          :data="scheduleds"
          @item-click="openCheckupDetail"
          search-placeholder="Cari nama atau keluhan..."
          show-name
        />
      </v-tab>
      <v-tab title="Selesai">
        <mental-health-participant-list
          :data="completeds"
          @item-click="openCheckupDetail"
          search-placeholder="Cari nama atau keluhan..."
          show-name
        />
      </v-tab>
      <v-tab title="Batal">
        <mental-health-participant-list
          :data="canceleds"
          @item-click="openCheckupDetail"
          search-placeholder="Cari nama atau keluhan..."
          show-name
        />
      </v-tab>
    </vue-tabs>
  </page-content>
</template>

<script>
import axios from "axios";
import MentalHealthParticipantList from "./components/MentalHealthParticipantList.vue";

export default {
  name: "mental-health-participant",
  components: {
    MentalHealthParticipantList,
  },
  data: function () {
    return {
      unscheduleds: [],
      scheduleds: [],
      completeds: [],
      canceleds: [],
    };
  },
  methods: {
    getCheckups: function (type) {
      this.startPageLoading();
      axios
        .get(this.apiBaseUrl + "mental-health/checkups", {
          params: {
            type,
          },
        })
        .then((response) => {
          this.stopPageLoading();
          const data = response.data.data;

          // Add status property
          data.forEach((item) => {
            item.status = type;
          });

          this[type + "s"] = data;
        })
        .catch(() => {
          this.stopPageLoading();
        });
    },
    openCheckupDetail: function (checkup) {
      this.$router.push({
        name: "mental-health-participant-detail",
        params: { id: checkup.id },
      });
    },
  },
  created: function () {
    this.getCheckups("unscheduled");
    this.getCheckups("scheduled");
    this.getCheckups("completed");
    this.getCheckups("canceled");
  },
};
</script>
